<script setup>
import PagePushCard from '@maison/components/molecules/PagePushCard.vue';
import { computed } from 'vue';
import { camelCase } from 'lodash-es';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  storeType: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  permalink: {
    type: String,
    required: true,
  },
  fullAddress: {
    type: String,
    required: true,
  },
  phone: {
    type: String,
    required: true,
  },
  searchImg: {
    type: Object,
    default: null,
  },
  seeMoreLabel: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const cta = computed(() => {
  return {
    text: props.seeMoreLabel || t('Search.card.ctaText'),
    target: {
      type: 'page',
      link: props.permalink,
    },
  };
});
</script>

<template>
  <page-push-card :title="name" :image="searchImg" :cta="cta" class="col-span-2 md:col-span-1" stacked>
    <template #description>
      <p>{{ $t(`Store.storeType.${camelCase(storeType)}`) }}</p>
      <p>{{ fullAddress }}</p>
      <p>{{ phone }}</p>
    </template>
  </page-push-card>
</template>
